const getFirstToken = (value = "") => String(value || "").trim().split(/\s+/)[0];

const getPrimaryName = (booking = {}) => {
  if (booking?.createdByFirstName) {
    return String(booking.createdByFirstName).trim();
  }

  if (booking?.createdByName) {
    return getFirstToken(booking.createdByName);
  }

  if (booking?.createdByUser) {
    return String(booking.createdByUser).split("@")[0].trim();
  }

  if (booking?.createdByEmail) {
    return String(booking.createdByEmail).split("@")[0].trim();
  }

  return "-";
};

export const formatBookerName = (booking = {}) => {
  const primaryName = getPrimaryName(booking);
  const nickname = String(booking?.createdByNickname || "").trim();

  if (!nickname || nickname === primaryName) {
    return primaryName;
  }

  return `${primaryName}(${nickname})`;
};

export const formatBookerLabel = (booking = {}) => {
  const name = formatBookerName(booking);
  const department = String(booking?.createdByDepartment || "").trim();

  return [name, department].filter(Boolean).join(" · ");
};
